import Vue from 'vue'

let currentIdentity = null;

export default {

    load(config) {
        return Vue.http.get('user/identity', config).then(currentIdentityResponse => {
            return currentIdentityResponse.body.data;
        });
    },

    getCurrent() {
        return new Promise((resolve, reject) => {
            if (currentIdentity) {
                resolve(currentIdentity);
                return;
            }

            this.load().then(identity => resolve(identity)).catch(error => reject(error));
        });
    },

    hasBecome() {
        return !(null === localStorage.getItem('became'));
    },

}
